import { StyleSheet, View } from 'react-native';

import { radii, spacing } from '@/theme';

import { onboardingColors } from './tokens';

interface StepIndicatorProps {
  readonly totalSteps: number;
  readonly activeStep: number;
}

export const StepIndicator = ({ totalSteps, activeStep }: StepIndicatorProps) => {
  const dots = Array.from({ length: totalSteps }, (_, index) => {
    const isActive = index === activeStep;
    const dotStyle = isActive ? styles.activeDot : styles.inactiveDot;
    const spacingStyle = index === totalSteps - 1 ? null : styles.dotSpacing;

    return (
      <View key={index} style={[dotStyle, spacingStyle]} testID={`step-indicator-dot-${index}`} />
    );
  });

  return <View style={styles.container}>{dots}</View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activeDot: {
    width: 24,
    height: 8,
    borderRadius: radii.sm,
    backgroundColor: onboardingColors.stepIndicatorActive,
  },
  inactiveDot: {
    width: 8,
    height: 8,
    borderRadius: radii.sm,
    backgroundColor: onboardingColors.stepIndicatorInactive,
  },
  dotSpacing: {
    marginRight: spacing[2],
  },
});
